import supabaseClient from '../supabase/supabase';

export const isSupabaseConfigured = true;
export const supabase = supabaseClient;